// Detalle de las novedades, agrupado por tipo (lib/queCambio.js). Lo usan la
// card compacta del Home / MiPAE en turno ("Ver novedades") y el punto
// discreto del menú ("Novedades"), así el mismo contenido se lee igual en
// las dos puertas. Abrirlo NO reconoce nada: reconocer es cerrar la card.
import { agruparNovedades } from "../lib/queCambio";

export default function NovedadesDetalle({ novedades, className = "" }) {
  const grupos = agruparNovedades(novedades);
  if (!grupos.length) {
    return <p className={`text-small text-ink-muted font-sans ${className}`}>Por ahora no hay novedades.</p>;
  }
  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      {grupos.map((g) => (
        <section key={g.tipo} aria-label={g.titulo}>
          <p className="text-micro uppercase tracking-wide text-ink-subtle font-sans font-semibold mb-1.5">{g.titulo}</p>
          <ul className="flex flex-col gap-2">
            {g.items.map((n) => (
              <li key={n.id} className="rounded-tk-sm bg-paper border border-edge px-3 py-2.5">
                <p className="text-small font-semibold text-ink font-sans">{n.titulo}</p>
                <p className="mt-0.5 text-small text-ink-muted font-sans leading-snug">{n.detalle}</p>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
